import React from 'react'
import { FormikProps } from 'formik'
import { AsyncSelect as UAsyncSelect } from 'bs-unified-ui'

interface AsyncSelectProps {
  forwardValues?: (val: any) => any
  revertValues?: (val: any) => any
  field: {
    name: string
    value: any
  }
  form: FormikProps<any>
  onCreateNew?: (val: any) => any
  disabled?: boolean
  [key: string]: any
}

const AsyncSelect: React.FC<AsyncSelectProps> = ({
  forwardValues = (v) => v,
  revertValues = (v) => v,
  field,
  form,
  onCreateNew = (v) => v,
  disabled = false,
  ...props
}) => (
  <UAsyncSelect
    {...field}
    values={forwardValues(field.value)}
    onChange={(v: any) => form.setFieldValue(field.name, revertValues(v))}
    onCreateNew={onCreateNew}
    disabled={disabled || !!form.values.__readOnly}
    {...props}
  />
)

export default AsyncSelect
